import useDashboardPageSectionName from '@projects/hooks/useDashboardPageSectionName';
import usePrevious from '@/helpers/custom-hooks/usePrevious';
import { useEffect } from 'react';
import { DashboardViewUpdatePayload } from '@experiment-management-shared/types';

type UseDashboardTabsOpts = {
  updateDashboardView: (data: DashboardViewUpdatePayload) => void;
};
const useDashboardTabs = ({ updateDashboardView }: UseDashboardTabsOpts) => {
  const currentTab: string = useDashboardPageSectionName();
  const previousTab = usePrevious(currentTab);

  useEffect(() => {
    if (!previousTab || previousTab === currentTab) return;

    if (
      (previousTab === 'archive' &&
        ['panels', 'experiments'].includes(currentTab)) ||
      (currentTab === 'archive' &&
        ['panels', 'experiments'].includes(previousTab))
    ) {
      updateDashboardView({
        table: {
          selection: []
        }
      });
    }
  }, [updateDashboardView, previousTab, currentTab]);

  return currentTab;
};

export default useDashboardTabs;
